import { useContext } from 'react';
import { PresentationContext } from '../contexts/PresentationContext.jsx';

/**
 * usePresentation — read/write the active presentation.
 *
 * Public API: { data, updateTool, clearTool, clearAll, savedFlash, loaded }
 *
 * The state itself, persistence to Supabase, and the debounced
 * autosave all live in src/contexts/PresentationContext.jsx; this
 * file is just the consumer hook so all the JSX-free tool files can
 * keep importing from `'../hooks/usePresentation.js'` unchanged.
 */
export function usePresentation() {
  const ctx = useContext(PresentationContext);
  if (!ctx) {
    throw new Error(
      'usePresentation must be used inside <PresentationProvider>. ' +
        'Make sure the route is wrapped in App.jsx.'
    );
  }
  return ctx;
}
